import axios from '@/libs/api.request'
var qs = require('qs')

// 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson/list',
        data,
        method: 'post'
    })
};
// 获取章节详情（树状图）
export const fetchChapterInfo = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson/chapter-list',
        data,
        method: 'post'
    })
};
// 删除章节
export const setDel = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson/chapter-delete',
        data,
        method: 'post'
    })
};
// 修改
export const modifySave = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson/chapter-edit',
        data,
        method: 'post'
    })
};
// 添加
export const addSave = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson/chapter-add',
        data,
        method: 'post'
    })
};
// 排序
export const setSort = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson/chapter-sort',
        data,
        method: 'post'
    })
};
// 同步
export const setSync = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson/synchronize',
        data,
        method: 'post'
    })
};
// 目录类型下拉
export const fetchDirectory = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson/directory-type-list',
        data,
        method: 'post'
    })
};
// 获取素材列表
export const fetchMaterialList = () => {

    return axios.request({
        url: '/lesson/element-material-list',
        method: 'post'
    })
};
// 确定上传答案素材
export const upMaterial = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson/add-answer-material',
        data,
        method: 'post'
    })
};